import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import Logo from "@/components/Logo";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("verifying");
  useEffect(() => {
    const token = params.get("token");
    if (!token) { setStatus("error"); return; }
    api.post("/auth/verify-email", { token }).then(() => setStatus("ok")).catch(() => setStatus("error"));
  }, [params]);
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="verify-page">
      <div className="w-full max-w-sm text-center">
        <div className="flex justify-center"><Logo size={38} /></div>
        {status === "verifying" && <p className="mt-8 text-muted-foreground" data-testid="verify-status">Verifying your email…</p>}
        {status === "ok" && <><h1 className="font-heading font-bold text-2xl mt-8" data-testid="verify-ok">Email verified ✓</h1><p className="text-sm text-muted-foreground mt-2">Your account is now secured.</p></>}
        {status === "error" && <><h1 className="font-heading font-bold text-2xl mt-8" data-testid="verify-error">Link invalid or expired</h1><p className="text-sm text-muted-foreground mt-2">Please request a new verification email from your account.</p></>}
        <p className="text-sm mt-6"><Link to="/login" className="text-primary hover:underline">Continue to login</Link></p>
      </div>
    </div>
  );
}
